import React from 'react'
import { useTheme } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const Logo = (props) => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Jura', sans-serif",
          fontSize: '32px',
          fontWeight: 700,
          color: '#ffffff',
          letterSpacing: '0.1em',
        }}
      >
        CONVEY
      </Typography>
    </Box>
  )
}
